import React, { Component } from 'react';

export default class Auth404 extends Component {
	render() {
		return (
			<div className="Auth404">
				<h3>Page not available.</h3>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/ui/components/Auth404/index.js